import { ProgramRequest } from '@/types/models';
import { ProgramRequestFilters } from '@/types/programRequests';
import { fetchWrapper } from '@/layers/presentation/utils/fetchWrapper';
import logger from '@/layers/support/monitoring/logger';
import { ProgramRequestStatus } from '@/types/modelEnums';

const LOG_MODULE = 'FE [Presentation / Services / ProgramRequests]';

export const fetchProgramRequests = async (
  filters?: ProgramRequestFilters,
): Promise<ProgramRequest[]> => {
  logger.debug(`${LOG_MODULE} fetchProgramRequests: begin`, { filters });

  try {
    const result = await fetchWrapper.get<ProgramRequest[]>(
      `/api/programs/requests/?sponsor_id=${filters?.sponsorId || ''}&program_id=${filters?.programId || ''}`,
    );

    logger.debug(`${LOG_MODULE} fetchProgramRequests: end`, { result });
    return result;
  } catch (error) {
    logger.error(`${LOG_MODULE} fetchProgramRequests`, { error });
    throw error;
  }
};

export const requestProgramAccess = async (
  providerEmail: string,
  patientId: string,
  programId: number,
): Promise<ProgramRequest> => {
  logger.debug(`${LOG_MODULE} requestProgramAccess: begin`, {
    providerEmail,
    patientId,
    programId,
  });

  try {
    const result = await fetchWrapper.post<ProgramRequest>(`/api/programs/requests`, {
      providerEmail,
      patientId,
      programId,
    });

    logger.debug(`${LOG_MODULE} requestProgramAccess: end`, { result });
    return result;
  } catch (error) {
    logger.error(`${LOG_MODULE} requestProgramAccess`, { error });
    throw error;
  }
};

export const cancelProgramRequest = async (programRequestId: number): Promise<ProgramRequest> => {
  logger.debug(`${LOG_MODULE} cancelProgramRequest: begin`, { programRequestId });

  try {
    const result = await fetchWrapper.put<ProgramRequest>(
      `/api/programs/requests/${programRequestId}`,
      { status: ProgramRequestStatus.Withdrawn },
    );

    logger.debug(`${LOG_MODULE} cancelProgramRequest: end`, { result });
    return result;
  } catch (error) {
    logger.error(`${LOG_MODULE} cancelProgramRequest`, { error });
    throw error;
  }
};

export const approveProgramRequest = async (programRequestId: number): Promise<ProgramRequest> => {
  logger.debug(`${LOG_MODULE} approveProgramRequest: begin`, { programRequestId });

  try {
    const result = await fetchWrapper.put<ProgramRequest>(
      `/api/programs/requests/${programRequestId}`,
      { status: ProgramRequestStatus.Approved },
    );

    logger.debug(`${LOG_MODULE} approveProgramRequest: end`, { result });
    return result;
  } catch (error) {
    logger.error(`${LOG_MODULE} approveProgramRequest`, { error });
    throw error;
  }
};

export const declineProgramRequest = async (programRequestId: number): Promise<ProgramRequest> => {
  logger.debug(`${LOG_MODULE} declineProgramRequest: begin`, { programRequestId });

  try {
    const result = await fetchWrapper.put<ProgramRequest>(
      `/api/programs/requests/${programRequestId}`,
      { status: ProgramRequestStatus.Declined },
    );

    logger.debug(`${LOG_MODULE} declineProgramRequest: end`, { result });
    return result;
  } catch (error) {
    logger.error(`${LOG_MODULE} declineProgramRequest`, { error });
    throw error;
  }
};
